import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'dateMultiLang',
    standalone: false
})
export class DateMultiLangPipe implements PipeTransform {
    dateTranform: string;
    transform(date: string, lang: string, small?: string): any {
      switch (lang) {
        case 'en':
          {
            if (small === 'small') {
              this.dateTranform = moment(date).parseZone().format('MM/DD/YYYY');
            } else {
              this.dateTranform = moment(date).parseZone().format('MM/DD/YYYY hh:mm:ss A');
            }
          }
          break;
        default:
          {
            if (small === 'small') {
              this.dateTranform = moment(date).parseZone().format('DD/MM/YYYY');
            } else {
              this.dateTranform = moment(date).parseZone().format('DD/MM/YYYY hh:mm:ss A');
            }
          }
          break;
      }
      return this.dateTranform;
    }
}
